import React, { FC } from 'react';
import classNames from 'classnames';

import { Amounts } from 'src/types/common/Amounts';
import { ImmutableTrip } from '../../../types/trips/Trips';
import CustomOfferExpiry from '../../../common/components/CustomOfferExpiry';
import Card from '../presentation/Card';
import TermsAndCancellation from '../TermsAndCancellation';
import CostBreakdown from '../CostBreakdown';
import s from './PriceSection.module.scss';

type OwnerPriceSectionProps = {
  amounts?: Amounts;
  listingUrl?: string;
  trip?: ImmutableTrip;
  readOnly?: boolean;
  highlighted?: boolean;
  renderCustomExpiry?: boolean;
  classNameModifier?: string;
};

const OwnerPriceSection: FC<OwnerPriceSectionProps> = ({
  amounts,
  listingUrl,
  trip,
  highlighted,
  readOnly,
  children,
  renderCustomExpiry = false,
  classNameModifier = '',
}) => (
  <>
    {children}

    {amounts?.price_sections?.map((priceSection) => (
      <CostBreakdown
        key={priceSection.id}
        priceSection={priceSection}
      />
    ))}

    {renderCustomExpiry && readOnly && (
      <Card
        highlighted={highlighted}
        classNameModifier={classNames(
          classNameModifier,
          { hoverEffect: !readOnly },
          'withZeroPadding',
        )}
      >
        <CustomOfferExpiry
          trip={trip}
        />
      </Card>
    )}

    {amounts?.cancellation_policy && (
      <div className={s.termsAndCancellation}>
        <TermsAndCancellation
          currency={amounts?.owner_currency}
          deposit={amounts?.listing_deposit}
          listingUrl={listingUrl}
          cancellationPolicy={amounts?.cancellation_policy}
          freeCancellationInMarketplace={amounts?.free_cancellation_in_marketplace}
        />
      </div>
    )}
  </>
);

export default OwnerPriceSection;
